import { LinkRequestStatus } from './link-request-status.enum';

export interface CreateFacilityCorporateLinkRequestDto {
  facilityId: string;
  corporationId: string;
}

export interface RejectFacilityCorporateLinkRequestDto {
  rejectionReason: string;
}

export interface FacilityCorporateLinkRequestDto {
  id: string;
  facilityId: string;
  facilityName: string;
  corporationId: string;
  corporationName: string;
  status: LinkRequestStatus;
  initiator: 'Facility' | 'Corporate';
  requestedByUserId: string;
  requestedByUserName: string | null;
  requestedByUserEmail: string | null;
  requestedAt: string; // DateTime as ISO string
  decidedByUserId: string | null;
  decidedByUserName: string | null;
  decidedByUserEmail: string | null;
  decidedAt: string | null; // DateTime as ISO string
  rejectionReason: string | null;
  createdAt: string; // DateTime as ISO string
  updatedAt: string; // DateTime as ISO string
}

// ============================================
// PAGINATION & FILTERING
// ============================================

export interface FacilityCorporateLinkRequestFilterDto {
  status?: LinkRequestStatus;
  facilityId?: string;
  corporationId?: string;
  searchTerm?: string;
  pageNumber?: number;
  pageSize?: number;
}

export interface UnaffiliatedFacilitiesFilterDto {
  searchTerm?: string;
  pageNumber?: number;
  pageSize?: number;
}

export interface AvailableCorporationsFilterDto {
  searchTerm?: string;
  pageNumber?: number;
  pageSize?: number;
}

// ============================================
// LIST ITEMS (for pickers)
// ============================================

export interface LocationDto {
  id?: number;
  city?: string;
  stateCode?: string;
  stateName?: string;
  zipCode?: string;
  fullAddress?: string;
}

export interface FacilityListItemDto {
  id: string;
  name: string;
  facilityTypeName?: string;
  status?: string;
  statusDisplay?: string;
  classification?: string;
  location?: LocationDto;
  timeZone?: string;
}

export interface CorporationListItemDto {
  id: string;
  name: string;
  status?: string;
}
